import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28cafce1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-row products__promoted-product-container" }
const _hoisted_2 = { class: "q-col-sm-12 products__promoted-product-container-inner" }
const _hoisted_3 = { class: "products__promoted-product q-p-1 q-position-relative q-d-flex q-flex-wrap" }
const _hoisted_4 = { class: "products__promoted-product-image-container q-col-4 q-col-md-12 q-p-0" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "products__promoted-product-info q-col-8 q-col-md-12 q-px-2 q-text-black q-text-start" }
const _hoisted_7 = { class: "products__promoted-product-title q-m-0 q-fw-bold" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]

import AutocompletePriceBox from '@/components/AutocompletePopup/AutocompletePriceBox.vue'
import {SmartSearchConfigInterface} from '@/core/types'

import {ref, inject, onUpdated, watch, toRef, computed} from 'vue';
import {generateStaticImage} from "@/core/utils";

export default /*#__PURE__*/_defineComponent({
  __name: 'PromotedProduct',
  props: ['promotedProduct'],
  setup(__props) {

const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)
const {width, height} = SmartSearchConfig.value.onfocus.topProduct.productImageSize
const {useQuarticImages} = SmartSearchConfig.value.serp.productImageSize

const props = __props;

const staticImage = computed(()=>{
  const imageLink  = props.promotedProduct.variants[0].image_link
  if (!useQuarticImages){
    return imageLink
  }
  return  imageLink ? generateStaticImage(imageLink, width, height) : generateStaticImage('https://static.quartic.com.pl/img/no-image/no-image.png', width, height);
})

const actualLink = ref(props.promotedProduct.link);
const clickLink = ref(props.promotedProduct.link_click);
const promotedProductTitle = ref(props.promotedProduct.title);
const promotedProductVariant = ref(props.promotedProduct.variants[0]);

const handleClick = () => {
  actualLink.value = clickLink.value;
};

onUpdated(() => {
  staticImage.value = ref(useQuarticImages ? generateStaticImage(props.promotedProduct.variants[0].image_link, width, height) : props.promotedProduct.variants[0].image_link).value;
})

watch(() => props.promotedProduct, (newValue) => {
  actualLink.value = newValue.link;
  clickLink.value = newValue.link_click;
  promotedProductTitle.value = newValue.title;
  promotedProductVariant.value = newValue.variants[0];
  staticImage.value = ref(useQuarticImages ? generateStaticImage(props.promotedProduct.variants[0].image_link, width, height) : props.promotedProduct.variants[0].image_link).value;
}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "products__promoted-product-image q-p-1",
            src: staticImage.value,
            alt: promotedProductTitle.value
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(promotedProductTitle.value), 1),
          _createVNode(AutocompletePriceBox, { product: promotedProductVariant.value }, null, 8, ["product"]),
          _createElementVNode("a", {
            href: actualLink.value,
            onClick: handleClick,
            class: "q-stretched-link"
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("a", {
          href: actualLink.value,
          onClick: handleClick,
          class: "q-stretched-link"
        }, null, 8, _hoisted_9)
      ])
    ])
  ]))
}
}

})